import API, {parts} from "@/api/FormFivesAPI"
import API2 from "@/api/FormA-G"
import {idUserForApi} from "@/controllers/UserController";
import store from "@/store";

class Form5Controller {
  constructor() {
    this.api = API;
    this.api2 = API2;
    this.mock = false;
  }

  _checkId(id) {
    if (!id)
      throw new Error('id cannot be null');
  }

  _checkPart(part) {
    if (!parts?.find(el => el === part))
      throw new Error('part not exist')
  }

  /**
   * @param {'part1a','part1b','part1v','part2', 'part3', 'part4', 'part5', 'part6', 'part7', 'part8', 'part9',
   * 'part10', 'part11', 'part12a', 'part12b', 'part13', 'part14', 'part15', 'part16', 'part17', 'part18', 'part19',
   * 'part20', 'part21', 'part22', 'formA'} part
   * @param {boolean} [full]
   * @param {boolean} [mapUslRows]
   * @param { Number | null | undefined } [orgId]
   * */
  async getForm(part, full = false, mapUslRows = false, orgId,) {
    try {
      orgId = orgId ?? idUserForApi(orgId);
      this._checkId(orgId);
      this._checkPart(part);
      const res = this.mock ? {data: ['part1a', 'part1b', 'part1v', 'part2', 'part3', 'part4',].includes(part) ? {} : []} : await this.api.read(orgId, part, full);
      let returnData = res.data;
      if (mapUslRows) {
        returnData = [];
        const usls = store.getters['spr/getUsls'].sort((a, b) => a.id - b.id);
        usls.forEach(el => {
          if (Object.hasOwnProperty.call(res.data, `usl${el.id}`) && res.data[`usl${el.id}`])
            returnData.push({id: Math.random(), uslName: el.name}, ...res.data[`usl${el.id}`]);
        });
      }
      return returnData
    } catch (e) {
      console.error('error getData ' + e.message)
      throw new Error('error getData ' + e.message)
    }
  }

  async getForm2(part, full = false, orgId,) {
    try {
      orgId = orgId ?? idUserForApi(orgId);
      this._checkId(orgId);
      const res = await this.api2.read2(orgId, part, full);
      if (part === 'formG') {
        return res.data
      } else {
        let returnData = [];
        const usls = store.getters['spr/getUsls'].sort((a, b) => a.id - b.id);
        usls.forEach(el => {
          if (Object.hasOwnProperty.call(res.data, `usl${el.id}`) && res.data[`usl${el.id}`]) {
            returnData.push({id: Math.random(), uslName: el.name}, ...res.data[`usl${el.id}`]);
          }
        });
        return returnData
      }
    } catch (e) {
      console.error('error getData ' + e.message)
      throw new Error('error getData ' + e.message)
    }
  }


  /**
   * @param {
   *     {
   *   "id": number,
   *   "spec": {
   *     "id": number,
   *   },
   *   "kcpUgs": {
   *     "id": number
   *   },
   *   "orgId": number,
   *   "gpsnm23K22": "string",
   *   "gpsnp23K22": "string",
   *   "gpdtb23K22": "string",
   *   "gpdte23K22": "string",
   *   "gptxt23K22": "string"
   * }
   * } data
   * @param {number} [orgId]
   * */
  async saveForm5(data, orgId) {
    try {
      console.log(orgId);
      orgId = orgId ?? idUserForApi(orgId);
      console.log(orgId);
      this._checkId(orgId);
      data.orgId = orgId;
      let res;
      if (data.id)
        res = this.mock ? {data: {...data}} : await this.api.changeForm5(data)
      else
        res = this.mock ? {data: {...data, id: Math.random()}} : await this.api.changeForm5(data);
      return res.data
    } catch (e) {
      console.error('error saveForm5 ' + e.message)
      throw new Error('error saveForm5 ' + e.message)
    }
  }

  /**
   *
   * @param { Number} [id]
   * */
  async deleteRow(id) {
    try {
      this._checkId(id);
      const res = this.mock ? {data: {}} : await this.api.deleteFormFive(id);
      return res.data
    } catch (e) {
      console.error('error deleteRow ' + e.message)
      throw new Error('error deleteRow ' + e.message)
    }
  }

  /**
   * @param {
   *     {
   *       "id": number,
   *           "form5Id"?: number,
   *           "form5KeyId": number,
   *           "oldValue": number,
   *           "kcpGroup": {id: number},
   *           "newValue": number,
   *           "appeal": string,
   *           "fileId": number,
   *          "orgId": number,
   * "form520Id"?: row.id,
   * }
   * } data
   * @param {number} [orgId]
   * */
  async saveForm(data, orgId) {
    try {
      orgId = orgId ?? idUserForApi(orgId);
      this._checkId(orgId);
      data.orgId = orgId;
      let res;
      if (data.id)
        res = this.mock ? {data: {...data}} : await this.api.changeForms(data)
      else
        res = this.mock ? {data: {...data, id: Math.random()}} : await this.api.changeForms(data);
      return res.data
    } catch (e) {
      console.error('error saveForm5 ' + e.message)
      throw new Error('error saveForm5 ' + e.message)
    }
  }
}

export default new Form5Controller()